import "./input-group.component.scss";

export default {
    template: require('./input-group.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
